import axios from 'axios';
import { createAction } from 'redux-actions';
import { get_service_endpoint } from 'ServiceEndpoints';
import { flash } from './CommonActions';

const GET_MARKETING_NEWS = createAction('GET_MARKETING_NEWS');
const CREATE_MARKETING_NEWS = createAction('CREATE_MARKETING_NEWS');
const GET_MARKETING_SOURCES_AND_CATEGORIES = createAction('GET_MARKETING_SOURCES_AND_CATEGORIES');

const marketingNewsEndpoint = get_service_endpoint('fabric');

export const getMarketingNews = (params) => async (dispatch) => {
  try {
    const res = await axios.get(`${marketingNewsEndpoint}/marketing/get-all-articles`, { params });
    dispatch(GET_MARKETING_NEWS(res.data.data));
  } catch (err) {
    dispatch(
      flash({
        message: err.response?.data?.message || 'Failed to fetch marketing news',
      }),
    );
  }
};

export const createMarketingNews = (requestData) => async (dispatch) => {
  try {
    const res = await axios.post(`${marketingNewsEndpoint}/marketing/create-article`, requestData);
    if (res?.data?.data?.success === false) {
      throw {
        response: { data: { message: res?.data?.data?.message || 'Failed to Create article' } },
      };
    }
    dispatch(CREATE_MARKETING_NEWS(res.data.data));
    return res.data;
  } catch (err) {
    dispatch(
      flash({
        message: err.response?.data?.message || 'Failed to create article',
      }),
    );
    throw err;
  }
};

export const getMarketingSourcesAndCategories = (params) => async (dispatch) => {
  try {
    const res = await axios.get(
      `${marketingNewsEndpoint}/marketing/get-all-sources-and-categories`,
      {
        params,
      },
    );
    const [sources, categories] = res.data.data;
    dispatch(GET_MARKETING_SOURCES_AND_CATEGORIES([sources, categories]));
  } catch (err) {
    dispatch(
      flash({
        message:
          err.response?.data?.message ||
          'Failed to fetch marketing sources and categories together',
      }),
    );
  }
};
